import axios from 'axios'

export const COMMISSION_TIER_OPTIONS = [
  { label: '默认（15%，最低1元）', value: 0 },
  { label: '一档 · 平台 30%', value: 30 },
  { label: '二档 · 平台 15%', value: 15 },
  { label: '三档 · 平台 10%（优秀）', value: 10 }
]

export function commissionTierLabel(pct) {
  const hit = COMMISSION_TIER_OPTIONS.find((o) => o.value === (pct || 0))
  return hit ? hit.label : `平台 ${pct}%`
}

/** 测评：非永久免费即可预置（含限时免费、未开售前已填原价） */
export function canPresetExamCommission(row) {
  if (!row) return false
  if (row.free === 1 && row.fee === 0 && !(row.originFee > 0)) return false
  return row.fee > 0 || row.originFee > 0
}

/** 博客：非标记为免费的资料（含 fee=0 待定价） */
export function canPresetBlogCommission(row) {
  if (!row) return false
  return row.free !== 1
}

/** 课程：管理端均可预置（含 fee=0 未开售） */
export function canPresetCourseCommission() {
  return true
}

export async function setContentCommissionTier(contentType, contentId, platformCommissionPct) {
  const token = localStorage.getItem('jwt_token')
  const response = await axios.post(
    '/api/v1/admin/content/commission-tier',
    { contentType, contentId, platformCommissionPct },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  )
  return response.data
}
